/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Goodforstudy2Inputs */

const en_goodforstudy2 = /** @type {(inputs: Goodforstudy2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studying`)
};

const de_goodforstudy2 = /** @type {(inputs: Goodforstudy2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lernen`)
};

/**
* | output |
* | --- |
* | "Studying" |
*
* @param {Goodforstudy2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodforstudy2 = /** @type {((inputs?: Goodforstudy2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodforstudy2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodforstudy2(inputs)
	return de_goodforstudy2(inputs)
});
export { goodforstudy2 as "goodForStudy" }